// extracted by mini-css-extract-plugin
export default {"Content":"t5Iy409wlSW9C2BZLbQ0"};